import api from "../../services/api";
import {bus} from "../../main";

export default {
	data: function() {
		return {
			show: false,
			filterMultiSelectText: "",
			poiCategories: []
		};
	},
	created() {
		this.getPoiCategories();
	},
	methods: {
		loadControls(map) {
			this.$nextTick(() => {
				var self = this;
				var controlDiv = document.createElement("div");
				var firstChild = document.getElementById("div-poi-categories");
				firstChild.style.backgroundColor = "#fff";
				firstChild.style.border = "none";
				firstChild.style.outline = "none";
				firstChild.style.width = "28px";
				firstChild.style.height = "28px";
				firstChild.style.borderRadius = "2px";
				firstChild.style.boxShadow = "0 1px 4px rgba(0,0,0,0.3)";
				firstChild.style.cursor = "pointer";
				firstChild.style.marginRight = "20px";
				firstChild.style.padding = "0px";
				controlDiv.appendChild(firstChild);
				var secondChild = document.createElement("div");
				secondChild.style.margin = "3px";
				secondChild.style.width = "28px";
				secondChild.style.height = "28px";
				secondChild.style.backgroundImage = "url(/icon-poi.png)";
				secondChild.style.backgroundSize = "25px 23px";
				secondChild.style.backgroundPosition = "0px 0px";
				secondChild.style.backgroundRepeat = "no-repeat";
				secondChild.title = "Filtro POI";
				firstChild.appendChild(secondChild);
				window.google.maps.event.addListener(map.$mapObject, "center_changed", function() {
					secondChild.style["background-position"] = "0 0";
				});

				firstChild.addEventListener("click", function() {
					self.show = !self.show;
				});
				controlDiv.index = 1;
				map.$mapObject.controls[window.google.maps.ControlPosition.RIGHT_BOTTOM].push(controlDiv);
			});
		},
		onPoiCategoriesSelectedChange(item) {
			item.selected = !item.selected;
		},
		getPoiCategories() {
			var self = this;
			api.getPoiCategoriesData().then(res => {
				self.poiCategories = res.map(function(item) {
					return {
						id: item.id,
						name: item.description || item.name,
						description: item.description,
						background_color: item.background_color || null,
						icon_image: item.icon_image,
						poi: [],
						selected: false
					};
				});

				self.getPois();
			});
		},
		getPois: function() {
			var self = this;
			var query = {
				page: 0,
				pageSize: 100000
			};
			api.getPoisData(query).then(res => {
				if (res.items && res.items.length > 0) {
					res.items.forEach(item => {
						var poiCategory = self.poiCategories.find(pc => {
							return pc.id == item.poi_category_id;
						});

						if (poiCategory) {
							poiCategory.poi.push(item);
						}
					});
				}
			});
		},
		getPoiDescription(poiId) {
			if (this.poiCategories && this.poiCategories.length > 0) {
				var poi = this.poiCategories.find(function(item) {
					return item.id == poiId;
				});

				if (poi) return poi.description;
			}

			return poiId;
		},
		removeFilter() {
			this.poiCategories.forEach(item => {
				item.selected = false;
			});
			this.show = false;

			bus.$emit("poi-category-filter-change", []);
		},
		filterHandler() {
			var itemsToShow = [];
			
			this.poiCategories.forEach(item => {
				if (item.selected) {
					if (item.poi.length > 0) {
						item.poi.forEach(p => {
							p.poi_category_icon_image = item.icon_image || "/assets/map/icon/blank.png";
							p.poi_category_fill_color = item.background_color;
							itemsToShow.push(p);
						});
					}
				}
			});
			this.show = false;

			bus.$emit("poi-category-filter-change", itemsToShow);
		}
	},
	computed: {
		poiCategoriesFiltered: function() {
			var self = this;
			var poiCategories = this.poiCategories;

			if (self.filterMultiSelectText) {
				poiCategories = poiCategories.filter(function(o) {
					return o.name.toLowerCase().indexOf(self.filterMultiSelectText.toLowerCase()) >= 0;
				});
			}

			return poiCategories;
		}
	}
};
